<template>
	<div id="app">
			<!-- <myMap name=""></myMap> -->
			 <router-view class="view"></router-view>
	</div>
</template>

<script>
	import HelloWorld from './components/HelloWorld.vue'

	export default {
		name: 'app',
		components: {
			HelloWorld,
		}
	}
</script>

<style lang="scss">
	@import "assets/css/common.scss";

	html,
	body {
		height: 100%;
		width: 100%;
	}

	* {
		padding: 0;
		margin: 0;
	}

	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		width: 1920px;
		height: 1080px;
		}
		.timeBox {
			span{
				margin-left: 20px;
			}
		}
	// 	// width: 100%;
	// 	// height: 100%;
	// 	.mapBox {
	// 		width: 100%;
	// 		height: 100%;
	// 	}
	// }
	// .loadIcon {
	// 	width: 60rpx;
	// 	height: 60rpx;
	// 	background:url('assets/css/loading.gif')no-repeat center;
	// 	background-size: 65%;
	// }
	
</style>
